module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/users/user-list/user-list.component.scss
// module id = ./src/app/routes/users/user-list/user-list.component.scss
// module chunks = 9